import { navigate } from '@reach/router'

type GoToTeamsBookingsT = () => Promise<void>

const goToTeamsBookings: GoToTeamsBookingsT = (hostname?: string) => {
  const path = hostname ? `${teamsBookingsPath}?hostname=${hostname}` : teamsBookingsPath
  return navigate(path)
}

export const teamsBookingsPath = '/teams_bookings'

export default goToTeamsBookings
